import { Outlet, createFileRoute } from '@tanstack/react-router';

import { FastGameProvider } from '@features/game/providers/FastGameProvider';

export const Route = createFileRoute('/game/pairing')({
  component: Layout,
});

function Layout() {
  return (
    <FastGameProvider>
      <Outlet />
    </FastGameProvider>
  );
}
